import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom-v5-compat";
import type { AppDispatch } from "@b2bportal/core-types";
import { HotelsShopActions } from "@tenant/hotels";
import type { PackageHotelShopPageProps } from "../types";
import { fetchPackageHotelShop } from "@/store/packages/thunks/hotels/fetchPackageHotelShop";

export const usePackageHotelShopPageFetch = ({
  search,
}: PackageHotelShopPageProps) => {
  const dispatch = useDispatch<AppDispatch>();

  const { lodgingId } = useParams();

  const packageToken = search.packageToken;

  useEffect(() => {
    // Guard against missing or invalid packageToken
    // Check for string "undefined" as defensive measure in case URL parsing coerces undefined to string
    if (!packageToken || packageToken === "undefined" || !lodgingId) {
      console.warn("No Package token or lodgingId provided");
      dispatch(HotelsShopActions.setLodgingUnavailable(true));
      return;
    }

    // Clear the selected room product when navigating to the shop page
    // This ensures the "choose room" button always goes to room selection first
    dispatch(HotelsShopActions.setSelectedRoomProduct(undefined));

    dispatch(
      fetchPackageHotelShop({
        props: {
          search,
          lodgingId,
          packageToken,
        },
      })
    );
    // we do not want to re-fetch the package hotel shop when the search params changes from the filters
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageToken, lodgingId, dispatch]);
};
